// extracted by mini-css-extract-plugin
export var planCard = "_sb-0";
export var planList = "_sb-1";